export default __webpack_public_path__ + "static/media/category-lifestyle.ca4b7958.jpg";